import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// Components
import Text from "new_components/atoms/Text";
import Icon from "new_components/atoms/Icon";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";

// Constants
import typography from "styles/typography";
import colors from "styles/colors";

const PoweredByLogo = ({
  text = "Powered by generative AI and culture experts.",
}) => {
  return (
    <StyledLogo>
      <Icon name={ICON_SET.aiIcon} color={colors.primary[500]} size={20} />
      <Text
        typographyStyle={typography.smallText.medium}
        color={colors.primary[500]}
      >
        {text}
      </Text>
    </StyledLogo>
  );
};

PoweredByLogo.propTypes = {
  text: PropTypes.string, // Allows customization of the "Powered by" text
};

export default PoweredByLogo;

// Styled Components
const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  background-color: ${colors.primary[50]};
  padding: 8px 18px;
  border-radius: 24px;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
`;